// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__2fqGn","title":"ClientCherryInfo_title__3n3hK","itemText":"ClientCherryInfo_itemText__1n2Eo"};